import { useEffect, useRef } from "react";

export function useIsUnmounted(callback: VoidFunction) {
  const isUnmountedRef = useRef(false);
  const stateRef = useRef(null);

  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    return () => {
      if (isUnmountedRef.current) {
        callbackRef.current();
      }
    };
  }, [isUnmountedRef, stateRef, callbackRef]);

  function setIsUnmounted() {
    isUnmountedRef.current = true;
  }

  return setIsUnmounted;
}

export default useIsUnmounted;
